import React from 'react';
import { Modal, Box, Detail, Paragraph, constants } from '@thecb/components';
import { useSelector } from 'react-redux';

const OUT_OF_BALANCE = 'OUT_OF_BALANCE';
const OutOfBalanceModal = ({ modals, submit, toggle }) => {
  const { isLoading } = useSelector((state) => state.closeout);
  const body = (
    <Box padding="0">
      <Paragraph
        fontSize="1rem"
        weight={constants.fontWeights.FONT_WEIGHT_REGULAR}
      >
        Your total is out of balance. If you continue you will closeout out of
        balance. There is no undoing this action.
      </Paragraph>
    </Box>
  );
  const modalHeaderText = (
    <Detail
      variant="large"
      weight={constants.fontWeights.FONT_WEIGHT_BOLD}
      color={constants.colors.WHITE}
    >
      Total out of balance
    </Detail>
  );

  return (
    <Modal
      isLoading={isLoading}
      isContinueActionDisabled={isLoading}
      modalHeaderText={modalHeaderText}
      modalBodyText={body}
      modalOpen={
        modals.closeout.modalIsOpen &&
        modals.closeout.modalId === OUT_OF_BALANCE
      }
      toggleModal={toggle}
      continueAction={submit}
      cancelAction={toggle}
      cancelButtonText="Edit totals"
      continueButtonText="Continue Closeout"
      defaultWrapper={false}
      modalHeaderBg={constants.colors.ERROR_COLOR}
    />
  );
};

export { OUT_OF_BALANCE, OutOfBalanceModal };
